import React from 'react';
import './featureContent.css';

function FeatureDisclaimer({ children }) {
    return <p className="fc-disclaimer">{children}</p>;
}

export default FeatureDisclaimer;
